"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var inversify_react_1 = require("inversify-react");
var lodash_1 = require("lodash");
var mobx_react_1 = require("mobx-react");
var NumberInput_1 = __importDefault(require("NumberInput/NumberInput"));
var QuoteItemStore_1 = require("QuoteV2/Stores/QuoteItemStore");
var QuoteSectionStore_1 = require("QuoteV2/Stores/QuoteSectionStore");
var react_1 = __importDefault(require("react"));
var QuoteTelemetry_1 = require("Telemetry/QuoteTelemetry");
var QuoteCurrencyFormatter_1 = __importDefault(require("Utils/QuoteCurrencyFormatter"));
var valueBlurGate_1 = __importDefault(require("ValueBlurGate/valueBlurGate"));
var SavedLineItemsLibrary_1 = __importDefault(require("../SavedLineItems/SavedLineItemsLibrary"));
var ContextMenu_1 = __importDefault(require("./ContextMenu/ContextMenu"));
var BillingScheduleHelpers_1 = require("./BillingScheduleHelpers");
var DiscountPanel_1 = __importDefault(require("./DiscountPanel"));
var BufferedNumberInput = (0, valueBlurGate_1.default)(NumberInput_1.default);
var PlanCardMenu = (function (_super) {
    __extends(PlanCardMenu, _super);
    function PlanCardMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PlanCardMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, item = _a.item, section = _a.section, onMenuOpened = _a.onMenuOpened, onMenuClosed = _a.onMenuClosed;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(ContextMenu_1.default, { onChange: function (show) {
                    if (show) {
                        onMenuOpened === null || onMenuOpened === void 0 ? void 0 : onMenuOpened();
                    }
                    else {
                        onMenuClosed === null || onMenuClosed === void 0 ? void 0 : onMenuClosed();
                    }
                }, button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.IconButton, __assign({ type: kaleidoscope_1.ButtonType.Tertiary, icon: react_1.default.createElement(icons_1.Edit, null), tooltip: { content: "Plan options" } }, buttonProps))); }, actions: __spreadArray(__spreadArray([
                    {
                        icon: react_1.default.createElement(icons_1.ArrowLeft, null),
                        tooltip: { content: "Move left" },
                        onClick: function () {
                            section.reorderLineItem(item, QuoteSectionStore_1.ReorderDirection.Up);
                            _this.quoteTelemetry.trackMoveLineItem();
                        },
                        disabled: (0, lodash_1.first)(section.items) === item,
                    },
                    {
                        icon: react_1.default.createElement(icons_1.ArrowRight, null),
                        tooltip: { content: "Move right" },
                        onClick: function () {
                            section.reorderLineItem(item, QuoteSectionStore_1.ReorderDirection.Down);
                            _this.quoteTelemetry.trackMoveLineItem();
                        },
                        disabled: (0, lodash_1.last)(section.items) === item,
                    },
                    {
                        icon: react_1.default.createElement(icons_1.Copy, null),
                        tooltip: { content: "Clone" },
                        onClick: function () {
                            var _a;
                            var clone = (0, lodash_1.cloneDeep)((0, lodash_1.omit)(item.angularModel, "$id", "integrations"));
                            if (section.itemSingleSelect && ((_a = clone.interactive) === null || _a === void 0 ? void 0 : _a.isOptional)) {
                                clone.interactive.isOptionalSelected = false;
                            }
                            section.addLineItems(clone, item.id);
                            var type = item.angularModel.type;
                            _this.quoteTelemetry.trackAddLineItem(type, section.displayMode, QuoteTelemetry_1.AddLineItemSource.Button);
                            var billingSchedule = (0, BillingScheduleHelpers_1.copyBillingSchedule)(type, item);
                            if (billingSchedule) {
                                _this.quoteTelemetry.trackBillingScheduleChange(billingSchedule);
                            }
                        },
                    }
                ], __read((!(item instanceof QuoteItemStore_1.QuoteProductItemStore)
                    ? [
                        {
                            icon: react_1.default.createElement(icons_1.SaveLineItem, null),
                            tooltip: { content: "Save plan" },
                            onClick: function () {
                                return _this.savedLineItemsLibrary.saveLineItem(_this.quoteCurrencyFormatter.getCurrencyCode(), (0, lodash_1.omit)(item.angularModel, "integrations"));
                            },
                        },
                    ]
                    : [])), false), [
                    {
                        icon: react_1.default.createElement(icons_1.Delete, null),
                        tooltip: { content: "Delete" },
                        isDestructive: true,
                        onClick: function () {
                            section.deleteLineItem(item);
                            _this.quoteTelemetry.trackDeleteLineItem();
                        },
                        disabled: section.items.length <= 1,
                        disabledReason: "Can't delete last plan",
                    },
                ], false), items: __spreadArray(__spreadArray([], __read((item instanceof QuoteItemStore_1.QuotePricedItemStore
                    ? [
                        {
                            label: "Discount",
                            panelContents: (react_1.default.createElement(DiscountPanel_1.default, { discountStore: item.discount, telemetryHierarchy: QuoteTelemetry_1.QuoteTelemetryHierarchy.PlanCard })),
                        },
                    ]
                    : [])), false), __read((item instanceof QuoteItemStore_1.QuotePricedItemStore || item instanceof QuoteItemStore_1.QuoteProductItemStore
                    ? [
                        {
                            label: "Properties",
                            panelContents: (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(kaleidoscope_1.Toggle, { label: "Tax exempt", value: item.taxExempt, onChange: function (isActive) {
                                        item.taxExempt = isActive;
                                        _this.quoteTelemetry.trackTaxExemptToggled(isActive, section.displayMode);
                                    } }),
                                react_1.default.createElement(kaleidoscope_1.Toggle, { label: "Optional plan", value: item.isOptional, onChange: function (isActive) {
                                        item.isOptional = isActive;
                                        _this.quoteTelemetry.trackPlanCardSectionOptional(isActive);
                                    } }),
                                react_1.default.createElement(kaleidoscope_1.Toggle, { label: "Optional quantity", value: item.isQuantityOptional, onChange: function (isActive) {
                                        item.isQuantityOptional = isActive;
                                        _this.quoteTelemetry.trackOptionalQuantityToggled(isActive, section.displayMode);
                                    } }),
                                item.isQuantityOptional && (react_1.default.createElement("div", { className: "item-menu-popup__quantity-range" },
                                    react_1.default.createElement(BufferedNumberInput, { label: "Min", size: kaleidoscope_1.TextInputSize.Small, value: item.quantityOptionalMin, onChange: function (min) {
                                            item.quantityOptionalMin = min;
                                        } }),
                                    react_1.default.createElement(BufferedNumberInput, { label: "Max", size: kaleidoscope_1.TextInputSize.Small, value: item.quantityOptionalMax, onChange: function (max) {
                                            item.quantityOptionalMax = max;
                                        } }))),
                                item instanceof QuoteItemStore_1.QuotePricedItemStore && (react_1.default.createElement(kaleidoscope_1.Toggle, { label: "Recommended", value: item.isRecommended, onChange: function (isActive) {
                                        item.isRecommended = isActive;
                                        _this.quoteTelemetry.trackRecommendedChange(isActive);
                                    } })))),
                        },
                    ]
                    : [])), false) })));
    };
    var _a, _b, _c;
    __decorate([
        (0, inversify_react_1.resolve)("quoteCurrencyFormatter"),
        __metadata("design:type", typeof (_a = typeof QuoteCurrencyFormatter_1.default !== "undefined" && QuoteCurrencyFormatter_1.default) === "function" ? _a : Object)
    ], PlanCardMenu.prototype, "quoteCurrencyFormatter", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("savedLineItemsLibrary"),
        __metadata("design:type", typeof (_b = typeof SavedLineItemsLibrary_1.default !== "undefined" && SavedLineItemsLibrary_1.default) === "function" ? _b : Object)
    ], PlanCardMenu.prototype, "savedLineItemsLibrary", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_c = typeof QuoteTelemetry_1.QuoteTelemetry !== "undefined" && QuoteTelemetry_1.QuoteTelemetry) === "function" ? _c : Object)
    ], PlanCardMenu.prototype, "quoteTelemetry", void 0);
    PlanCardMenu = __decorate([
        mobx_react_1.observer
    ], PlanCardMenu);
    return PlanCardMenu;
}(react_1.default.Component));
exports.default = PlanCardMenu;
